











































import { Vue, Component, Prop } from 'vue-property-decorator'
import colors from 'src/assets/colors'
import IntegerInput from 'components/IntegerInput.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    IntegerInput
  }
})
export default class ItemTopicSlidesEditorGroup extends Vue {
  colors = colors

  @Prop()
  readonly item!: Item

  @Prop()
  readonly group!: Json

  setOption (option: string, value: any) {
    const slidesSettings: Json = {}
    slidesSettings[`groups:${this.group.id}:id`] = this.group.id
    slidesSettings[`groups:${this.group.id}:${option}`] = value || null
    this.item.data?.save({ slidesSettings })
  }
}
